import { TextField } from "@mui/material";
import React, { ChangeEvent, useState } from "react";
import useFilterParams from "../../hooks/useFilterParams";

const FromDateFilter = () => {
  const { from, setFrom } = useFilterParams();
  const [value, setValue] = useState(from.split(":")[0]);
  const [isFocused, setIsFocused] = useState(false);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    setTimeout(() => {
      setFrom(`${e.target.value}T00:00`);
    }, 1500);
  };

  return (
    <TextField
      placeholder="من"
      type={isFocused || value ? "date" : "text"}
      value={value}
      onChange={handleChange}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      sx={{ flex: "1", minWidth: "200px" }}
    />
  );
};

export default FromDateFilter;
